module.exports = __webpack_public_path__ + "static/media/report-uniform-icon.90555e10.svg";